// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__VUi3-","inner":"PageNotFound_inner__-xnTy","goBack":"PageNotFound_goBack__X0F8M"};